module.exports = __webpack_public_path__ + "img/kemenko.bdcfbe6b.png";